import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import SegmentedTabs from '../../components/SegmentedTabs';
import ScreenshotDetail from '../../components/ScreenshotDetail';
import { selectedCaptureSrc, SelectedCaptureKey } from '../../lib/selectedCaptures';
import './GarageSpecEvidence.css';

const UNITS: {
  label: string;
  key: SelectedCaptureKey;
  crop: { x: number; y: number; width: number; height: number };
  alt: string;
  caption: string;
  fullImageLabel: string;
}[] = [
  {
    label: 'Engine & Performance',
    key: 'garageEngine',
    crop: { x: 48, y: 1255, width: 1224, height: 425 },
    alt: 'Engine specifications in RidePulse for a 2023 Aprilia RS 660, including power, 49.4 lb-ft of torque, transmission and final drive',
    caption: 'Engine and torque.',
    fullImageLabel: 'View full-size engine specifications',
  },
  {
    label: 'Wheels & Tires',
    // Crop shows the Wheels & Tires header plus front/rear rows.
    key: 'garageTires',
    crop: { x: 48, y: 1660, width: 1224, height: 315 },
    alt: 'Wheel and tire specifications in RidePulse for a 2023 Aprilia RS 660, showing 120/70ZR17 front and 180/55ZR17 rear sizes',
    caption: 'Front and rear tire sizes.',
    fullImageLabel: 'View full-size tire specifications',
  },
];

const GarageSpecEvidence: React.FC = () => {
  const { theme, dsColors, colors } = useTheme();
  const [unit, setUnit] = useState(0);
  const u = UNITS[unit];
  const src = selectedCaptureSrc(u.key, theme);
  return (
    <div
      className="spe-detail"
      style={{ '--st-accent': dsColors.primary, '--st-hairline': colors.border, '--st-text': colors.textPrimary } as React.CSSProperties}
    >
      <p className="text-sm mb-4" style={{ color: colors.textSecondary }}>
        2023 Aprilia RS 660.
      </p>
      <SegmentedTabs label="Specification detail" options={UNITS.map((x) => x.label)} selected={unit} onSelect={setUnit}>
        <ScreenshotDetail
          src={src}
          crop={u.crop}
          alt={u.alt}
          caption={u.caption}
          fullImageLabel={u.fullImageLabel}
        />
      </SegmentedTabs>
    </div>
  );
};

export default GarageSpecEvidence;
